import React, { createContext, useContext, useState, useEffect } from 'react';
import Casdoor from 'casdoor-js-sdk';
import sdkConfig from '../casdoorConfig';

const AuthContext = createContext({});

// Initialize Casdoor SDK
const casdoor = new Casdoor({
  serverUrl: sdkConfig.serverUrl,
  clientId: sdkConfig.clientId,
  appName: sdkConfig.appName,
  organization: sdkConfig.organizationName,
  redirectPath: sdkConfig.redirectPath,
});

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const userInfo = await casdoor.getUserInfo();
      if (userInfo) {
        setUser(userInfo);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const login = () => {
    casdoor.signin();
  };

  const logout = async () => {
    await casdoor.signout();
    setUser(null);
  };

  const handleCallback = async () => {
    try {
      const userInfo = await casdoor.getUserInfo();
      if (userInfo) {
        setUser(userInfo);
        // Redirect to home after successful login
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Callback handling failed:', error);
    }
  };

  const value = {
    user,
    loading,
    login,
    logout,
    checkAuth,
    handleCallback,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
